interface IFaq {
    title: string;
    summary: string;
    content: string;
  }
  
  const faqs: { umum: IFaq[]; peperiksaan: IFaq[]; "kenaikan-pangkat": IFaq[] } =
    {
      umum: [
        {
          title: "Umum 1",
          summary: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
          content:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        },
        {
          title: "Umum 2",
          summary: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
          content:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        },
        {
          title: "Umum 3",
          summary: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
          content:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        },
      ],
      peperiksaan: [
        {
          title: "Peperiksaan 1",
          summary: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
          content:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        },
        {
          title: "Peperiksaan 2",
          summary: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
          content:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        },
        {
          title: "Peperiksaan 3",
          summary: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
          content:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        },
      ],
      "kenaikan-pangkat": [
        {
          title: "Kenaikan Pangkat 1",
          summary: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
          content:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        },
        {
          title: "Kenaikan Pangkat 2",
          summary: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
          content:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        },
        {
          title: "Kenaikan Pangkat 3",
          summary: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
          content:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        },
      ],
    };
  
  export { faqs };
  